/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_ResumeInputs */

const en_directory_submit_enrich_resume = /** @type {(inputs: Directory_Submit_Enrich_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-run this step only`)
};

const zh_directory_submit_enrich_resume = /** @type {(inputs: Directory_Submit_Enrich_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅重跑此模块`)
};

/**
* | output |
* | --- |
* | "Re-run this step only" |
*
* @param {Directory_Submit_Enrich_ResumeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_resume = /** @type {((inputs?: Directory_Submit_Enrich_ResumeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_ResumeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_resume(inputs)
	return zh_directory_submit_enrich_resume(inputs)
});
export { directory_submit_enrich_resume as "directory.submit.enrich.resume" }